import { z } from 'zod';
import { Role } from './auth.js';
export const InviteUserRequest = z.object({
    email: z.string().email(),
    fullName: z.string().min(1).max(200),
    role: Role,
    roles: z.array(Role).min(1).optional(),
});
export const PatchUserRequest = z.object({
    fullName: z.string().min(1).max(200).optional(),
    role: Role.optional(),
    roles: z.array(Role).min(1).optional(),
});
export const UserSummary = z.object({
    id: z.string(),
    email: z.string(),
    fullName: z.string(),
    role: Role,
    roles: z.array(Role),
    status: z.enum(['invited', 'active', 'blocked']),
    emailVerified: z.boolean(),
    createdAt: z.string(),
});
//# sourceMappingURL=users.js.map